import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { AbilitiesSelectors } from '@recruitee/abilities/data';
import { AccountSelectors } from '@recruitee/account';
import { filterBoolean } from '@recruitee/common';
import { Ability, Company } from '@recruitee/http/types';

import { GdprConfigurationSelectors } from '../store/configuration/gdpr-configuration.store';

@Injectable({ providedIn: 'root' })
export class GdprService {
  public gdprConfiguration$ = this.store
    .select(GdprConfigurationSelectors.data)
    .pipe(filterBoolean);

  public canManageGdpr: boolean;
  public canManageCandidates: boolean;

  private currentCompany: Company;

  constructor(private store: Store) {
    this.store.select(AbilitiesSelectors.abilityMap).subscribe(abilityMap => {
      this.canManageGdpr = abilityMap[Ability.ManageGdpr];
      this.canManageCandidates = abilityMap[Ability.ManageCandidates];
    });

    this.store
      .select(AccountSelectors.currentCompany)
      .pipe(filterBoolean)
      .subscribe(currentCompany => (this.currentCompany = currentCompany));
  }

  public isGdprEnabled(withManageCandidatesOnly?: boolean): boolean {
    if (!this.currentCompany) return false;

    return this.hasGdprEnabled(this.currentCompany, withManageCandidatesOnly);
  }

  public get gdprSettingEnabled(): boolean {
    return this.currentCompany.settings.gdprEnabled;
  }

  public isGdprEnabled$(withManageCandidatesOnly?: boolean) {
    return this.store.select(AccountSelectors.currentCompany).pipe(
      filterBoolean,
      map(company => this.hasGdprEnabled(company, withManageCandidatesOnly)),
    );
  }

  private hasGdprEnabled(company: Company, withManageCandidatesOnly?: boolean): boolean {
    return (
      company.settings.gdprEnabled &&
      (withManageCandidatesOnly ? this.canManageCandidates : this.canManageGdpr)
    );
  }
}
